import { render, staticRenderFns } from "./AdminMChoices.vue?vue&type=template&id=2bec0ed9&scoped=true&"
import script from "./AdminMChoices.vue?vue&type=script&lang=js&"
export * from "./AdminMChoices.vue?vue&type=script&lang=js&"
import style0 from "./AdminMChoices.vue?vue&type=style&index=0&id=2bec0ed9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec0ed9",
  null
  
)

export default component.exports